import { useEffect, useState } from "react";
import { useProjects } from "../lib/ProjectContext";
import { api } from "../lib/apiClient";

interface PendingPromotion {
  id: string;
  question: string;
  originalDirective: string;
  correction: string;
  submittedBy: string;
  submittedAt: string;
}

export function ReviewPage() {
  const { selectedProjectId } = useProjects();
  const [items, setItems] = useState<PendingPromotion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [acting, setActing] = useState<string | null>(null);

  function load() {
    if (!selectedProjectId) return;
    setLoading(true);
    api
      .get<{ promotions: PendingPromotion[] }>(`/api/projects/${selectedProjectId}/promotions/pending`)
      .then((data) => setItems(data.promotions))
      .catch((err) => setError(err.message || "Failed to load review queue."))
      .finally(() => setLoading(false));
  }

  useEffect(load, [selectedProjectId]);

  async function decide(id: string, approve: boolean) {
    setActing(id);
    try {
      await api.post(`/api/promotions/${id}/approve`, { approve });
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Action failed.");
    } finally {
      setActing(null);
    }
  }

  if (loading) return <p className="muted">Loading review queue…</p>;

  return (
    <div className="content-col">
      <h2 style={{ marginTop: 0 }}>Review queue</h2>
      <p className="muted">
        Corrections inspectors flagged for promotion into the knowledge base as reviewed veteran knowledge. Nothing
        here becomes answerable until you approve it.
      </p>
      {error && <p className="error-text">{error}</p>}
      {items.length === 0 && <p className="muted">Nothing pending review.</p>}
      {items.map((item) => (
        <div className="card" key={item.id}>
          <p className="muted">Question</p>
          <p>{item.question}</p>
          <p className="muted">Original directive</p>
          <p>{item.originalDirective}</p>
          <p className="muted">Suggested correction</p>
          <p style={{ fontWeight: 600 }}>{item.correction}</p>
          <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem" }}>
            <button className="btn btn-primary" disabled={acting === item.id} onClick={() => decide(item.id, true)}>
              Approve &amp; add to knowledge base
            </button>
            <button
              className="btn btn-secondary"
              disabled={acting === item.id}
              onClick={() => decide(item.id, false)}
            >
              Reject
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
